module.exports = __webpack_public_path__ + "img/vipusericon.0639e580.png";